import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import {
  EventBoxWrapper,
  EventImageWrapper,
  ManageMentPreviewInfo,
  ManagementRightWrapper,
  PreviewFacilitiesWrapper,
} from "../styles";
import { pubState } from "../../../recoil/pub.atom";
import ManageMentPreviewImage from "./previewImageSection";
import { Swiper, SwiperSlide } from "swiper/react";

const ManageMentPreview = () => {
  const [pub, setPub] = useRecoilState(pubState);
  const [formatFacilities, setFormatFacilities] = useState<string[]>(
    pub?.facilities ? pub?.facilities : [],
  );

  useEffect(() => {
    if (!pub) return;
    setFormatFacilities(pub.facilities);
    console.log(pub?.facilities);
  }, [pub?.facilities]);

  return (
    <ManagementRightWrapper>
      <img src="/image-web/management/phone.svg" alt="phone" />
      <div className="phone-wrapper">
        <ManageMentPreviewImage />

        {pub?.events && pub?.events.length > 0 && (
          <EventBoxWrapper>
            <div className="title">매장 이벤트</div>
            <Swiper
              slidesPerView={1.1}
              centeredSlides={true}
              spaceBetween={12}
              className="swiper"
            >
              {pub?.events.map((item, i) => {
                return (
                  <SwiperSlide key={i}>
                    <EventImageWrapper>
                      <img alt="event" src={item.imageUrl}></img>
                    </EventImageWrapper>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </EventBoxWrapper>
        )}

        <ManageMentPreviewInfo>
          <div className="title">매장 이용 안내</div>
          <div
            className="box"
            dangerouslySetInnerHTML={{
              __html: pub?.informationUse
                ? pub.informationUse.replace(/\n/g, "<br />")
                : "",
            }}
          />
        </ManageMentPreviewInfo>

        <ManageMentPreviewInfo>
          <div className="title">업체 정보</div>
          <div className="box">
            <div className="info">상호: {pub?.cafeName}</div>
            <div className="info">대표자명: {pub?.ownerName}</div>
            <div className="info">주소: {pub?.newAddress}</div>
            <div className="info">전화번호: {pub?.phoneNumber}</div>
            <div className="info">
              사업자번호: {pub?.employerId ? pub?.employerId : "-"}
            </div>
          </div>
        </ManageMentPreviewInfo>

        <PreviewFacilitiesWrapper>
          {formatFacilities.map((item, index) => (
            <div className="item" key={index}>
              <img
                src={`/image-web/management/preview-${item}.svg`}
                alt="preview"
              />
              <div className="title">{item}</div>
            </div>
          ))}
        </PreviewFacilitiesWrapper>
      </div>
    </ManagementRightWrapper>
  );
};
export default ManageMentPreview;
